import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

import { fetchProfile } from "../../../../utils/fetchProfile";
import Navbar from "../../../../Components/Navbar";
import { useLocation } from "react-router-dom";
import {
  TextField,
  Button,
  MenuItem,
  ButtonGroup,
  Autocomplete,
  Box,
  Grid,
} from "@mui/material";
import { Slide, toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import TableMultiple from "./Table/TableMultiple";
import TableSingle from "./Table/TableSingle";
import ModalProcessCrosscoding from "../../../../Components/Fragments/Modals/ModalProcessCrosscoding";
import { enableFuzzyMatchingFeature } from "../../../../utils/constant";

function CrosscodingBrand() {
  const accessToken = Cookies.get("access_token") || "";

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const retailerUrl = queryParams.get("retailer");

  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [needRefresh, setNeedRefresh] = useState(false);
  const [fuzzyIsActive, setFuzzyIsActive] = useState(enableFuzzyMatchingFeature ? true : false);

  const [currentPageMultiple, setCurrentPageMultiple] = useState(1);
  const [currentPageSingle, setCurrentPageSingle] = useState(1);

  const [dataProfile, setDataProfile] = useState([]);
  const [formBody, setFormBody] = useState({
    multiple_selection: [],
    target_update: {},
    category_mode: "",
    retailer: "",
  });

  const [crosscodeLabel, setCrosscodeLabel] = useState("");
  const [processModalOpen, setProcessModalOpen] = useState(false);

  const [selectedList, setSelectedList] = useState("crosscode");
  const [selectedRetailer, setSelectedRetailer] = useState([]);
  const [retailerOptions, setRetailerOptions] = useState([]);

  const [multipleFilterValue, setMultipleFilterValue] = useState("");
  const [singleFilterValue, setSingleFilterValue] = useState("");

  const goToProduct = () => {
    window.location.replace(
      `/data-processing/crosscode-product?retailer=${retailerUrl}`
    );
  };

  const optionsWithAll = [
    // { id: "all-retailers", retailer: "All Retailers" },
    ...retailerOptions,
  ];

  async function fetchRetailerOptions() {
    setIsLoading(true);

    setRetailerOptions([]);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/data-processing-raw/rta_mt/retailer`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const { data } = await response.json();
        setRetailerOptions(data);
      } else {
        setRetailerOptions([]);
      }
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  }

  // process crosscoding
  const handleProcessCrosscode = () => {
    const isMultipleSelectionEmpty =
      !Array.isArray(formBody?.multiple_selection) ||
      formBody.multiple_selection.length === 0;

    const isTargetUpdateEmpty =
      !formBody?.target_update ||
      Object.keys(formBody.target_update).length === 0;

    if (!isMultipleSelectionEmpty && !isTargetUpdateEmpty) {
      setCrosscodeLabel(
        <span
          dangerouslySetInnerHTML={{
            __html:
              "Apakah anda yakin untuk melakukan proses <strong>crosscode</strong> pada brand terpilih?",
          }}
        />
      );
      setFormBody((prev) => ({
        ...prev,
        category_mode: "crosscode",
      }));
      setProcessModalOpen(true);
    } else {
      if (isMultipleSelectionEmpty && isTargetUpdateEmpty) {
        toast.error(
          "Harap memilih brand retailer dan brand master terlebih dahulu!"
        );
      } else if (isMultipleSelectionEmpty) {
        toast.error("Harap memilih brand retailer terlebih dahulu!");
      } else if (isTargetUpdateEmpty) {
        toast.error("Harap memilih brand master terlebih dahulu!");
      }
    }
  };

  const handleProcessExclude = () => {
    const isMultipleSelectionEmpty =
      !Array.isArray(formBody?.multiple_selection) ||
      formBody.multiple_selection.length === 0;

    if (!isMultipleSelectionEmpty) {
      setCrosscodeLabel(
        <span
          dangerouslySetInnerHTML={{
            __html:
              "Apakah anda yakin untuk melakukan proses <strong>exclude</strong> pada brand terpilih?",
          }}
        />
      );
      setFormBody((prev) => ({
        ...prev,
        category_mode: "excluded",
      }));
      setProcessModalOpen(true);
    } else {
      if (isMultipleSelectionEmpty) {
        toast.error("Harap memilih brand retailer terlebih dahulu!");
      }
    }
  };

  const handleCloseProcess = () => {
    setCrosscodeLabel("");
    setFormBody((prev) => ({
      ...prev,
      category_mode: "",
    }));
    setProcessModalOpen(false);
  };

  const handleProcess = async () => {
    setIsLoading(true);
    try {
      let apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/data-processing-raw-crosscoding/rta_mt/brand`;

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formBody),
      });

      if (response.ok) {
        setProcessModalOpen(false);
        toast.success(`Data berhasil diproses`);
        setCurrentPageMultiple(1);
        setCurrentPageSingle(1);
        setNeedRefresh(true);
        setFormBody({
          multiple_selection: [],
          target_update: {},
          category_mode: "",
          retailer: selectedRetailer,
        });
      } else {
        const message = await response.json();
        toast.error(message.detail);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Gagal memproses data!");
    }
    setIsLoading(false);
  };

  const handleRetailerChange = (event) => {
    setSelectedRetailer(event.target.value);
    setFormBody((prev) => ({
      ...prev,
      retailer: event.target.value,
    }));
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, [
        "COA",
        "TL",
        "13",
        "14",
      ]);
      fetchRetailerOptions();
    }, 100);
    return () => {
      clearTimeout(handler);
    };
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (retailerUrl) {
        setSelectedRetailer(retailerUrl);
        setFormBody((prev) => ({
          ...prev,
          retailer: retailerUrl,
        }));
      }
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [retailerUrl]);

  useEffect(() => {
    if (formBody.multiple_selection.length > 0) {
      const latestItem =
        formBody.multiple_selection[formBody.multiple_selection.length - 1];

      setSingleFilterValue(latestItem.ret_brand);
    } else if (formBody.multiple_selection.length === 0) {
      setSingleFilterValue("");
    }
  }, [formBody.multiple_selection]);

  if (notAllowAccessPage) {
    return (
      <div>
        <Navbar
          active="Data Processing"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        />
        <div>Not allowed to access this page</div>
      </div>
    );
  }
  return (
    <Box>
      <Navbar
        active="Data Processing"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <Box className="content" sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: { xs: "flex-start", sm: "space-between" },
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <ArrowBackIcon
              onClick={() => {
                window.close();
              }}
              sx={{
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#d4d4d4ff",
                },
                borderRadius: "100%",
                padding: "4px",
                cursor: "pointer",
              }}
            />
            <h4 style={{ fontSize: 20, fontFamily: "Montserrat" }}>
              Crosscode - Brand
            </h4>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: { xs: "flex-start", sm: "space-between" },
              gap: 2,
              alignItems: "center",
            }}
          >
            <Button
              className="button-pros"
              variant="contained"
              sx={{
                backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
                border: "1px solid hsl(186, 89.90%, 27.30%)",
                borderRadius: "4px",
                color: "#fff",
                fontSize: "14px",
                height: "fit-content",
                textTransform: "none",
                "&:hover": {
                  backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                },
              }}
              onClick={goToProduct}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Go to Crosscoding Product"}
            </Button>
            <Button
              className="button-pros"
              variant="contained"
              sx={{
                backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
                border: "1px solid hsl(186, 89.90%, 27.30%)",
                borderRadius: "4px",
                color: "#fff",
                fontSize: "14px",
                height: "fit-content",
                textTransform: "none",
                "&:hover": {
                  backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                },
              }}
              onClick={() => {
                window.location.href = `/data-processing/crosscode-brand/crosscode?retailer=${selectedRetailer}`;
              }}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Show Crosscoded Brand"}
            </Button>
            <Button
              className="button-pros"
              variant="contained"
              sx={{
                backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
                border: "1px solid hsl(186, 89.90%, 27.30%)",
                borderRadius: "4px",
                color: "#fff",
                fontSize: "14px",
                textTransform: "none",
                "&:hover": {
                  backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                },
              }}
              onClick={() => {
                window.location.href = `/data-processing/crosscode-brand/excluded?retailer=${selectedRetailer}`;
              }}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Show Excluded Brand"}
            </Button>
          </Box>
        </Box>

        {/* <Box
          className="container-textfield"
          sx={{ mb: 3, mt: { xs: 0, sm: -2 }, textAlign: "center" }}
        >
          <h4 style={{ fontSize: 20, fontFamily: "Montserrat" }}>
            Crosscode - Brand
          </h4>
        </Box> */}

        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                boxShadow:
                  "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                borderRadius: "5px",
                p: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: { xs: "flex-start", sm: "space-between" },
                  alignItems: { xs: "flex-start", sm: "flex-start" },
                  mb: 2,
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <h4 style={{ fontSize: 14, fontFamily: "Montserrat" }}>
                    Retailer
                  </h4>
                  <Autocomplete
                    size="small"
                    options={optionsWithAll || []}
                    getOptionLabel={(item) => item.retailer || ""}
                    value={
                      optionsWithAll?.find(
                        (item) => item.retailer === selectedRetailer
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleRetailerChange({
                        target: { value: newValue ? newValue.retailer : "" },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className="reporting-textfield"
                        sx={{ minWidth: { xs: "200px", sm: 400 } }}
                        placeholder="Select Retailer"
                      />
                    )}
                    isOptionEqualToValue={(item, value) =>
                      item.retailer === value.retailer
                    }
                    disableClearable
                  />
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                  {enableFuzzyMatchingFeature && (
                    <Button
                      className="button-pros"
                      variant="contained"
                      sx={{
                        backgroundImage: `${
                          fuzzyIsActive
                            ? "linear-gradient(#806706ff, #6d5905ff)"
                            : "linear-gradient(#d8af08ff, #c39e07ff)"
                        }`,
                        border: `1px solid ${
                          fuzzyIsActive ? "#9f8106ff" : "#ba9606ff"
                        }`,
                        borderRadius: "4px",
                        color: "#fff",
                        fontSize: "14px",
                        textTransform: "none",
                        "&:hover": {
                          backgroundImage: `${
                            fuzzyIsActive
                              ? "linear-gradient(#6d5905ff, #594804ff)"
                              : "linear-gradient(#cda508ff, #ae8c06ff)"
                          }`,
                        },
                      }}
                      onClick={() => {
                        if (fuzzyIsActive) {
                          setFuzzyIsActive(false);
                        } else {
                          setFuzzyIsActive(true);
                        }
                      }}
                      disabled={isLoading}
                    >
                      {isLoading ? "Loading..." : "Fuzzy Matching"}
                    </Button>
                  )}
                  <Button
                    className="button-pros"
                    variant="contained"
                    sx={{
                      backgroundImage: "linear-gradient(#07c30aff, #06ae09ff)",
                      border: "1px solid #069b09ff",
                      borderRadius: "4px",
                      color: "#fff",
                      fontSize: "14px",
                      textTransform: "none",
                      "&:hover": {
                        backgroundImage:
                          "linear-gradient(#069b09ff, #058f08ff)",
                      },
                    }}
                    onClick={handleProcessCrosscode}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Crosscode Selected Brand"}
                  </Button>
                  <Button
                    className="button-pros"
                    variant="contained"
                    sx={{
                      backgroundImage: "linear-gradient(#c43232ff, #ac2828ff)",
                      border: "1px solid hsla(0, 90%, 27%, 1.00)",
                      borderRadius: "4px",
                      color: "#fff",
                      fontSize: "14px",
                      textTransform: "none",
                      "&:hover": {
                        backgroundImage:
                          "linear-gradient(#b02c2cff, #8a2222ff)",
                      },
                    }}
                    onClick={handleProcessExclude}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Exclude Selected Brand"}
                  </Button>
                </Box>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box sx={{ mb: 2 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-between",
                        alignItems: { xs: "flex-start", sm: "center" },
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Box>
                        <h4
                          style={{
                            fontSize: 14,
                            fontFamily: "Montserrat",
                            margin: 0,
                          }}
                        >
                          Brand Retailer
                        </h4>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column-reverse", sm: "row" },
                          justifyContent: "space-between",
                          alignItems: { xs: "flex-start", sm: "center" },
                          gap: 2,
                        }}
                      >
                        <h4
                          style={{
                            fontSize: 14,
                            fontFamily: "Montserrat",
                            margin: 0,
                          }}
                        >
                          Filter
                        </h4>
                        <TextField
                          value={multipleFilterValue}
                          onChange={(e) => {
                            if (formBody.multiple_selection.length > 0) {
                              setFormBody((prev) => ({
                                ...prev,
                                multiple_selection: [],
                              }));
                            }
                            setCurrentPageMultiple(1);
                            setMultipleFilterValue(e.target.value);
                            setSingleFilterValue(e.target.value);
                          }}
                          placeholder="Value"
                          sx={{ width: { xs: "100%", sm: 200 } }}
                          size="small"
                        />
                      </Box>
                    </Box>

                    <TableMultiple
                      filterValue={multipleFilterValue}
                      formBody={formBody}
                      setFormBody={setFormBody}
                      currentPage={currentPageMultiple}
                      setCurrentPage={setCurrentPageMultiple}
                      needRefresh={needRefresh}
                      setNeedRefresh={setNeedRefresh}
                      selectedRetailer={selectedRetailer}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-between",
                        alignItems: { xs: "flex-start", sm: "center" },
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Box>
                        <h4
                          style={{
                            fontSize: 14,
                            fontFamily: "Montserrat",
                            margin: 0,
                          }}
                        >
                          Brand Master
                        </h4>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column-reverse", sm: "row" },
                          justifyContent: "space-between",
                          alignItems: { xs: "flex-start", sm: "center" },
                          gap: 2,
                        }}
                      >
                        <h4
                          style={{
                            fontSize: 14,
                            fontFamily: "Montserrat",
                            margin: 0,
                          }}
                        >
                          Filter
                        </h4>
                        <TextField
                          value={singleFilterValue}
                          onChange={(e) => {
                            setFormBody((prev) => ({
                              ...prev,
                              target_update: {},
                            }));
                            setCurrentPageSingle(1);
                            setSingleFilterValue(e.target.value);
                          }}
                          placeholder="Value"
                          sx={{ width: 200 }}
                          size="small"
                        />
                      </Box>
                    </Box>
                    <TableSingle
                      filterValue={singleFilterValue}
                      formBody={formBody}
                      setFormBody={setFormBody}
                      currentPage={currentPageSingle}
                      setCurrentPage={setCurrentPageSingle}
                      needRefresh={needRefresh}
                      setNeedRefresh={setNeedRefresh}
                      selectedRetailer={selectedRetailer}
                      fuzzyIsActive={fuzzyIsActive}
                      enableFuzzyMatchingFeature={enableFuzzyMatchingFeature}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <ModalProcessCrosscoding
        label={crosscodeLabel}
        open={processModalOpen}
        onClose={handleCloseProcess}
        onProcess={handleProcess}
        isLoading={isLoading}
        selectedProcessData={formBody.category_mode}
      />
    </Box>
  );
}

export default CrosscodingBrand;
